import { t } from 'i18next';
import { FC } from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { FieldsRow, FormSelect } from '../../../../../../shared/components/form';
import {
  ArticleCashAssistTabDataRes,
  CashAssistTabOptionsRes,
} from '../../../../services/article.service';
import { cashAssistTabState } from '../cashassist.state';
import { getVisibilityOptions } from '../options/visibility.options.tsx';

export const CashAssistForm: FC<IPostForm> = ({ formMethods, cashAssistTabOptions }) => {
  const {
    formState: { errors, dirtyFields },
  } = formMethods;

  const onSubmit = (e: React.FocusEvent<HTMLFormElement>) => {
    if (
      !errors[e.target.name as keyof ArticleCashAssistTabDataRes] &&
      !!dirtyFields[e.target.name as keyof ArticleCashAssistTabDataRes]
    ) {
      cashAssistTabState.pub.save();
    }
  };

  return (
    <FormProvider {...formMethods}>
      <form noValidate onBlur={onSubmit}>
        <FieldsRow>
          <FormSelect
            name='caTemplateId'
            label={t('article.template')}
            width='220px'
            options={(cashAssistTabOptions.cashAssistTemplates as []) || []}
          />
          <FormSelect
            name='caProductGroupId'
            label={t('article.sales_group')}
            width='220px'
            options={(cashAssistTabOptions?.productionGroups as []) || []}
          />
        </FieldsRow>
        <FieldsRow mt={4}>
          <FormSelect
            name='caVisibilityStatusId'
            label={t('article.visibility')}
            width='220px'
            disableClearable
            options={getVisibilityOptions(t)}
          />
        </FieldsRow>
      </form>
    </FormProvider>
  );
};

interface IPostForm {
  formMethods: UseFormReturn<ArticleCashAssistTabDataRes>;
  cashAssistTabOptions: CashAssistTabOptionsRes;
}
